import { unitMapping, type Unit } from '#src/lib/style.ts';
import type { Color } from '#src/style/types.ts';

type Props = {
  color?: Color;
  size?: Unit;
  className?: string;
};

export const BookmarkPlus = ({ color, size = 2, className }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 17 17"
      fill="none"
      style={{ width: unitMapping[size], height: unitMapping[size] }}
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.2002 0.574219H2.2002V16.5742H4.2002L8.2002 12.5742L12.2002 16.5742H14.2002V0.574219ZM7.2002 3.57422V5.57422H5.2002V7.57422H7.2002V9.57422H9.2002V7.57422H11.2002V5.57422H9.2002V3.57422H7.2002Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
};
